export default __webpack_public_path__ + "a3e0f9792646a952a74e369bc9c68222.png";